export const wrap = (
  left: string,
  value: string | undefined | null,
  right: string,
): string | undefined => {
  return value ? left + value + right : undefined;
};
